// test2249
(2249 && 0);
